import { gql } from '@apollo/client';

export const GET_FLYER = gql`
  query getFlyer($input: GetFlyerInput!) {
    getFlyer(input: $input) {
      flyerId
      startDate
      endDate
      submittedAt
      districtId
      isNew
      isUpcoming
      title
      titleTranslations {
        es
      }
      status
      frontImageUrl
      pageCount
      email
      pages {
        imageUrl
        pageNumber
        userText
      }
      pdfUrl
      type
      ownerId
      activities
      categories
      schools {
        schoolId
        name
        branding {
          logoAlt
          logoLinkUrl
          logoUrl
        }
      }
      criticalDate
      isFavorite
      isRead
      grades
      eventLocation
      mapUrl
      viewsPerDay
      savedAmount
      minTargetGradeOrAge
      maxTargetGradeOrAge
      org {
        orgId
        name
        description
        disclaimer
        schoolApproved
        links {
          call
          website
          email
        }
      }
      ctas {
        type
        value
        isPrimary
        id
        paragraph {
          pageNumber
          vertices {
            x
            y
          }
        }
      }
      featuredLinkIds
      wcagHtml
      translations
      isQuarantined
      isCommunityFree
    }
  }
`;
